import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../redux-store";

/** Deleted types included, for showing lines that already use one. */
export const selectExtraCO2Types = (state: RootState) =>
  state.data.extraCO2Types.types;

/** The types that can still be managed and picked for new lines. */
export const selectLiveExtraCO2Types = createSelector(
  selectExtraCO2Types,
  (types) => types.filter((type) => type.deletedAt === null)
);
